import { specificReasonDetail } from './disqualification-rule-reason';

// Non-LLM / non-Rule disqualifications (manual admin DQ, or pre-SourceCode legacy rows) have no AI
// assessment to fetch. Surface the recorded feedback when present, otherwise an honest non-AI
// message, instead of the misleading "No AI disqualification rationale is available". Returns null
// when the LLM/Rule branches own the render.
export const nonAiDisqualificationReason = (
  sourceCode?: string,
  scrubbingFeedback?: string,
): { detail: string } | null => {
  if (sourceCode === 'LLM' || sourceCode === 'Rule') return null;
  return {
    detail: specificReasonDetail(scrubbingFeedback)
      ?? 'This nomination was disqualified manually; no AI rationale was recorded.',
  };
};
